var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "registersSuc" }, [
    _c("div", { staticClass: "title" }, [
      _c(
        "svg",
        {
          staticClass: "icon",
          attrs: { slot: "image", "aria-hidden": "true" },
          slot: "image"
        },
        [_c("use", { attrs: { "xlink:href": "#icon-daiwenzilogo" } })]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "iconTitle" }, [
      _c(
        "div",
        {
          on: {
            click: function($event) {
              return _vm.$router.push("/register")
            }
          }
        },
        [
          !this.isDirection
            ? _c("img", {
                attrs: { src: require("../assets/images/goleft.png") }
              })
            : _c("img", {
                attrs: { src: require("../assets//images/goRight.png") }
              })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          on: {
            click: function($event) {
              return _vm.$router.push("/newIndex")
            }
          }
        },
        [
          _c("img", {
            class: { mirrorRotateLevel: _vm.isDirection },
            attrs: { src: require("../assets/images/close.png") }
          })
        ]
      )
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "text" }, [_vm._v(_vm._s(_vm.$t("9000030")))]),
    _vm._v(" "),
    _c("div", { staticClass: "btns" }, [
      _c(
        "div",
        {
          staticClass: "downLoad",
          on: {
            click: function($event) {
              return _vm.$router.push("/download")
            }
          }
        },
        [_vm._v("\n            " + _vm._s(_vm.$t("9000031")) + "\n        ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "goBack",
          on: {
            click: function($event) {
              return _vm.$router.push("/newIndex")
            }
          }
        },
        [_vm._v("\n            " + _vm._s(_vm.$t("9000032")) + "\n        ")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("img", { attrs: { src: require("../assets/images/uscIcon.png") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00ac05dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00ac05dc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/registersSuc.vue
// module id = sMhQ
// module chunks = 0